function upperFirst(value) {
  return typeof value !== "string" ? "" : value.charAt(0).toUpperCase() + value.slice(1);
}

export { upperFirst };
//# sourceMappingURL=upper-first.js.map
